import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_UTILITY_METABASE_CHART_GET_BY_PARTNER_ID } from 'api/utilityActionTypes';

export default async function getByPartnerId({ state, utilityApiClient }, { partnerId, reload }) {
  typeCheck('partnerId::PositiveNumber', partnerId);
  typeCheck('reload::Maybe Boolean', reload);

  const metabaseChartsPath = ['utilityMetabaseCharts', 'byPartnerId', partnerId];
  const metabaseCharts = state.get(metabaseChartsPath);

  if (metabaseCharts && !reload) {
    return;
  }

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_METABASE_CHART_GET_BY_PARTNER_ID,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(metabaseCharts) {
      state.set(metabaseChartsPath, metabaseCharts);
    },
  });
}
